import React from 'react'
import Riepilogo from './riepilogo'
import RiepilogoCard from './riepilogoCard'
import RiepilogoCardDettagli from './riepilogoCardDettagli'
import { RiepilogoButton } from './buttons'

const RiepilogoDettagli = (props) => {
  return (
    <Riepilogo
      title='Hai completato la prima parte!'
      subtitle='Controlla le informazione inserite e passa al gruppo successivo'
    >
      <RiepilogoButton text='continua' onClick={props.incrementStep} />
      <RiepilogoCard cardTitle='Dettagli annuncio'>
        <RiepilogoCardDettagli {...props} />
      </RiepilogoCard>
    </Riepilogo>
  )
}

export default RiepilogoDettagli
